var React = require('react');

function ArrowLargeRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.75 11.999H23.25","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.75 22.499L23.25 11.999L12.75 1.49902","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowLargeRightInline.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowLargeRightInline;

ArrowLargeRightInline.default = ArrowLargeRightInline;
